import _extends from "@babel/runtime/helpers/esm/extends";
var _path;
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgRestaurant = function SvgRestaurant(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      d: "M2.478 17.522h15.044M2.478 5.875v.85c0 .675.264 1.323.734 1.8.47.479 1.108.747 1.773.747.665 0 1.303-.268 1.773-.746.733-.745.735-1.677.735-2.651m-5.015 0h5.015m-5.015 0 1.671-3.397h11.702l1.671 3.397m-15.044 0h15.044m-10.03 0v.85c0 .675.265 1.323.735 1.8.47.479 1.108.747 1.773.747.665 0 1.303-.268 1.773-.746s.734-1.126.734-1.802m0 0v-.85m0 .85c0 .676.265 1.324.735 1.802s1.108.746 1.773.746c.665 0 1.303-.268 1.773-.746s.734-1.126.734-1.802v-.85M4.419 17.522v-8.25M15.581 17.522v-8.25M7.33 17.522v-3.235c0-.43.188-.84.522-1.144a1.874 1.874 0 0 1 1.258-.474h1.78c.472 0 .924.17 1.258.474.334.303.521.715.521 1.144v3.235",
      stroke: "currentColor",
      strokeWidth: 1.6,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }))
  }));
};
export default SvgRestaurant;